import React, { useEffect, useState } from "react";
import { useSearchParams } from "react-router-dom";
import { api } from "@/lib/api";
import ProductCard from "@/components/ProductCard";
import { MagnifyingGlass } from "@phosphor-icons/react";
import { Input } from "@/components/ui/input";
import usePageMeta from "@/hooks/usePageMeta";

const TABS = [
  { key: "all", label: "Full Arsenal" },
  { key: "flagship", label: "Flagship" },
  { key: "starter", label: "Sovereign Starters" },
];

export default function Catalog() {
  usePageMeta(
    "The Arsenal",
    "Browse the full EIGOO Provisions Arsenal — 58 armored digital provisions, from flagship AI SaaS to niche business starter blueprints. Filter, search, engage."
  );
  const [params, setParams] = useSearchParams();
  const [products, setProducts] = useState([]);
  const [q, setQ] = useState("");
  const sector = params.get("sector") || "all";

  useEffect(() => {
    api.get("/products", { params: { sector, q } }).then((r) => setProducts(r.data.products));
  }, [sector, q]);

  return (
    <div className="max-w-7xl mx-auto px-6 lg:px-12 py-16" data-testid="catalog-page">
      <div className="mb-12">
        <span className="overline">// Provisions Arsenal</span>
        <h1 className="heading-display text-5xl md:text-6xl mt-4 mb-4">The Arsenal</h1>
        <p className="text-white/60 font-light max-w-2xl">
          Every armored provision. Every Sovereign sector. Filter, search, and engage.
        </p>
      </div>

      {/* Tabs + Search */}
      <div className="flex flex-wrap items-center justify-between gap-4 mb-10 pb-6 border-b border-white/5">
        <div className="flex flex-wrap gap-2" data-testid="catalog-tabs">
          {TABS.map((t) => (
            <button
              key={t.key}
              data-testid={`catalog-tab-${t.key}`}
              onClick={() => setParams(t.key === "all" ? {} : { sector: t.key })}
              className={`px-5 py-2.5 text-xs uppercase tracking-[0.2em] font-semibold border transition-all ${
                sector === t.key
                  ? "border-[#FFD700] text-[#FFD700] bg-[#FFD700]/5"
                  : "border-white/10 text-white/60 hover:border-white/30 hover:text-white"
              }`}
            >
              {t.label}
            </button>
          ))}
        </div>

        <div className="relative w-full sm:w-72">
          <MagnifyingGlass size={16} className="absolute left-3 top-1/2 -translate-y-1/2 text-white/40" />
          <Input
            data-testid="catalog-search"
            value={q}
            onChange={(e) => setQ(e.target.value)}
            placeholder="Search the arsenal..."
            className="pl-10 bg-[#0c0c0c] border-white/10 text-white text-sm rounded-none h-11"
          />
        </div>
      </div>

      {/* Grid */}
      {products.length === 0 ? (
        <div className="py-20 text-center text-white/40 font-mono text-xs uppercase tracking-widest">
          No provisions matching this query.
        </div>
      ) : (
        <>
          <div className="font-mono text-[0.65rem] uppercase tracking-[0.25em] text-white/40 mb-6">
            Total provisions: <span className="text-[#FFD700]">{products.length}</span>
          </div>
          <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-5">
            {products.map((p, i) => (
              <ProductCard key={p.id} product={p} idx={i} />
            ))}
          </div>
        </>
      )}
    </div>
  );
}
